import createStore from 'redux-zero';

import { translation } from './translation';

const initialState = {
    timer_justify: null,
    isStart: false,
    debug: false,
    devMode: false,
    pre_test: false,
    etest: {
        //attempt
        question: {
            option: {
                contents: []
            },
            files: []
        },
        timer: 0
    },
    selected: {
        content: "",
        id: ""
    },
    selectedOption: '',
    isError: false,
    token: '',
    type: 'pt',
    fullname: '',
    dial_code: '+1',
    phone_number: '',
    email: '',
    level: '',
    message: '',
    message_type: '',
    message_title: '',
    wantReset: false,
    playSoundCount: 0,
    sounds: [],
    texts: [],
    images: [],
    playSoundOnStart: false,
    finishTest: true,
    isPlaying: false,
    organization: {},
    isValidToken: true,
    levels: [],
    isEtest: true,
    isMaintenance: false,
    isPrepare: false,
    logout: false,
    email_confirmation: '',
    translation,
    lang: 'en',
    taken_test: false,
    user_id: '',
    session_id: ''
}

const store = createStore(initialState);

export default store;